import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PredictionDetails = lazy(() =>
  import("@predictions/PredictionDetails").then((module) => ({ default: module.PredictionDetails }))
);

export const PredictionDetailsNRO: NavigationRoutingObject = {
  Component: PredictionDetails,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) => t("predictions", "Predictions"),
  pageNameForTracking: () => "Predictions",
  getDeveloperNavigationAllowed: (
    { predictionFeatures, hasPermission },
    { type }: { type?: "churn" | "purchase" | "recommendations" } = {}
  ) => {
    if (!hasPermission("appGroup", { permission: "viewPredictions" })) {
      return false;
    }

    switch (type) {
      case "churn":
        return predictionFeatures.churn.ENABLED;
      case "purchase":
        return predictionFeatures.purchase.ENABLED;
      case "recommendations":
        return predictionFeatures.recommendations.ENABLED;
      default:
        return (
          predictionFeatures.churn.ENABLED ||
          predictionFeatures.purchase.ENABLED ||
          predictionFeatures.recommendations.ENABLED
        );
    }
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/predictions/predictions/:appGroupId",
};
